import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { GET_STATISTICS_CABLE_API_URL, GET_STATISTICS_CABLE_HIGHWAY_API_URL, GET_STATISTICS_COMPONENT_API_URL, GET_STATISTICS_WIFI_CITY_API_URL } from './OpticApiConfig';
import { ROLE_DEFAULT } from './Constants/ConstantsOptics';

const Home = (role) => {
  const [result, setResult] = useState([]);
  const [resultHighway, setResultHighway] = useState([]);
  const [resultComponent, setResultComponent] = useState([]);
  const [resultWifi, setResultWifi] = useState([]);
  const [error, setError] = useState(null);  
  const token = localStorage.getItem('token');

useEffect(() => {
  const fetchAll = async () => {
    try {
      const headers = { Authorization: `Bearer ${token}` };

      const [
        cable,
        cableHighway,
        component,
        wifi
      ] = await Promise.all([
        axios.get(GET_STATISTICS_CABLE_API_URL, { headers }),
        axios.get(GET_STATISTICS_CABLE_HIGHWAY_API_URL, { headers }),
        axios.get(GET_STATISTICS_COMPONENT_API_URL, { headers }),
        axios.get(GET_STATISTICS_WIFI_CITY_API_URL, { headers })
      ]);

      setResult(cable.data);
      setResultHighway(cableHighway.data);
      setResultComponent(component.data);
      setResultWifi(wifi.data);

    } catch (error) {
      console.error("Error fetching data", error);
      setError("Ошибка при загрузке данных");
    }
  };

  fetchAll();
}, []);

  return (
    <>
     {role.role === ROLE_DEFAULT && (
      <label className="account-warning">
        Текущий аккаунт: <span className="default-text">Default</span>. Обратитесь к инженеру для назначения необходимых прав доступа.
      </label>
     )}


  {/* Первая таблица */}
  <div className="dashboard-container">
  <div  className="scroll-container" style={{paddingBottom: "10px"}} >
        <table className="results-table-home"> 
          <thead>
          <tr>
            <td colspan="4"  style={{
                textAlign: 'center',
                fontSize: '14px',
                backgroundImage: 'linear-gradient(to right,rgb(56, 56, 56), #434343)',
                textShadow: '2px 2px 4px rgb(0, 0, 0)'
               
              }}>
              За 7 дней
            </td>
          </tr>
            <tr>
              <th >Округ</th>
              <th>Подземка</th>
              <th>Воздушка</th>
              <th>Всего</th>
            </tr>
          </thead>
          <tbody>
            {result.length === 0 ? (
              <tr>
                <td colSpan="4" className="no-data">Нет данных для отображения</td>
              </tr>
            ) : (
              result.map((item, index) => (
                <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"} style={{textShadow: '2px 2px 4px rgb(54, 54, 54)'}}>
                  <td>{item.city}</td>
                  <td style={{ color: item.subway === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)'}}>
                    {item.subway}
                  </td>
                  <td style={{ color: item.air === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
                     {item.air}
                  </td>
                  <td  className="total-cell" style={{ color: item.total === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
                    {item.total}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

        {/* CABLE HIGHWAY */}
     
       
        <table className="results-table-home"> 
          <thead>
          <tr>
            <td colspan="4"  style={{
                textAlign: 'center',
                fontSize: '14px',
                backgroundImage: 'linear-gradient(to right,rgb(56, 56, 56), #434343)',
                textShadow: '2px 2px 4px rgb(0, 0, 0)'
               
              }}>
              За 7 дней (ранг 1/2)
            </td>
          </tr>
            <tr>
              <th>Город</th>
              <th>Подземка</th>
              <th>Воздушка</th>
              <th>Всего</th>
            </tr>
          </thead>
          <tbody>
            {result.length === 0 ? (
              <tr>
                <td colSpan="4" className="no-data">Нет данных для отображения</td>
              </tr>
            ) : (
              resultHighway.map((item, index) => (
                <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"} style={{ textShadow: '2px 2px 4px rgb(44, 44, 44)'}}>
                  <td>{item.city}</td>
                  <td style={{ color: item.subway === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
                    {item.subway}
                  </td>
                  <td style={{ color: item.air === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)'  }}>
                     {item.air}
                  </td>
                  <td  className="total-cell" style={{ color: item.total === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
                    {item.total}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
     
        {/* инфраструктура */}
        <table className="results-table-home">
          <thead>
             <tr>
            <td colspan="6"  style={{
                textAlign: 'center',
                fontSize: '14px',
                backgroundImage: 'linear-gradient(to right,rgb(56, 56, 56), #434343)',
                textShadow: '2px 2px 4px rgb(0, 0, 0)'
               
              }}>
              Инфраструктура
            </td>
          </tr>
            <tr>
              <th>Город</th>
              <th>Колодец</th>
              <th>Опора</th>
              <th>Фоб</th>
              <th>Муфта</th>
              <th>Понбокс</th>
            </tr>
          </thead>
          <tbody>
            {resultComponent.length === 0 ? (
              <tr>
                <td colSpan="6" className="no-data">Нет данных для отображения</td>
              </tr>
            ) : (
              resultComponent.map((item, index) => (
                <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"} style={{textShadow: '2px 2px 4px rgb(44, 44, 44)'}}>
                  <td >{item.city}</td>
                  <td style={{ color: item.well === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
                    {item.well}  
                  </td>
                  <td style={{ color: item.pillar === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
                     {item.pillar}
                  </td>
                  <td style={{ color: item.fob === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
                     {item.fob}
                  </td>
                  <td style={{ color: item.coupling === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
                     {item.coupling}
                  </td>
                  <td style={{ color: item.ponBox === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
                     {item.ponBox}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      

        {/* wifi */}
        <table className="results-table-home">
          <thead>
             <tr>
            <td colspan="6"  style={{
                textAlign: 'center',
                fontSize: '14px',
                backgroundImage: 'linear-gradient(to right,rgb(56, 56, 56), #434343)',
                textShadow: '2px 2px 4px rgb(0, 0, 0)'
               
              }}>
              Wi-Fi
            </td>
          </tr>
            <tr>
              <th>Город</th>
              <th>Base Station</th>
              <th>Station</th>
              <th>Access Point</th>
            </tr>
          </thead>
          <tbody>
            {resultWifi.length === 0 ? (
              <tr>
                <td colSpan="6" className="no-data">Нет данных для отображения</td>
              </tr>
            ) : (
              resultWifi.map((item, index) => (
                <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"} style={{textShadow: '2px 2px 4px rgb(44, 44, 44)'}}>
                  <td >{item.city}</td>
                  <td style={{ color: item.baseStation === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
                    {item.baseStation}  
                  </td>
                  <td style={{ color: item.station === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
                     {item.station}
                  </td>
                  <td style={{ color: item.accessPoint === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
                     {item.accessPoint}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
       

       
     
<img 
  src='./logo.png'  
  alt='Logo' 
  style={{
    height: "50px",
    width: "50px",
    transition: "all 0.5s ease", // плавное изменение размера и transform
    animation: "rotate 20s linear infinite"
  }}
  onMouseEnter={(e) => {
    e.currentTarget.style.width = "150px";
    e.currentTarget.style.height = "150px";
    e.currentTarget.style.transform = "rotate(360deg)";
    e.currentTarget.style.animation = "none"; // Остановить вращение
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.width = "50px";
    e.currentTarget.style.height = "50px";
    e.currentTarget.style.transform = "rotate(0deg)";
    e.currentTarget.style.animation = "rotate 20s linear infinite"; // Возобновить вращение
  }}
  // onMouseEnter={(e) => {
  //   e.currentTarget.style.transform = "scale(1.1) rotate(360deg)";
  //   e.currentTarget.style.animation = "none"; // Останавливаем вращение при наведении
  // }}
  // onMouseLeave={(e) => {
  //   e.currentTarget.style.transform = "scale(1) rotate(0deg)";
  //   e.currentTarget.style.animation = "rotate 20s linear infinite"; // Возвращаем вращение
  // }}
/>
</div>





      
      </>

  );
};

export default Home;

//   return (
//     <>
//      {role.role === ROLE_DEFAULT && (
//       <label className="account-warning">
//         Текущий аккаунт: <span className="default-text">Default</span>. Обратитесь к инженеру для назначения необходимых прав доступа.
//       </label>
//      )}

//     <div style={{ display: 'flex', justifyContent: 'space-between' }}>
//       <div  className="scroll-container" style={{ flex: 1, marginTop: '10px', maxWidth:"400px",   height: '80vh', overflowY: 'auto', paddingBottom: '10px' }}>
        
//         <table className="results-table"> 
//           <thead>
//           <tr>
//             <td colspan="4"  style={{
//                 textAlign: 'center',
//                 fontSize: '14px',
//                 backgroundImage: 'linear-gradient(to right,rgb(56, 56, 56), #434343)',
//                 textShadow: '2px 2px 4px rgb(0, 0, 0)'
               
//               }}>
//               За 7 дней
//             </td>
//           </tr>
//             <tr>
//               <th >Округ</th>
//               <th>Подземка</th>
//               <th>Воздушка</th>
//               <th>Всего</th>
//             </tr>
//           </thead>
//           <tbody>
//             {result.length === 0 ? (
//               <tr>
//                 <td colSpan="4" className="no-data">Нет данных для отображения</td>
//               </tr>
//             ) : (
//               result.map((item, index) => (
//                 <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"} style={{textShadow: '2px 2px 4px rgb(54, 54, 54)'}}>
//                   <td>{item.city}</td>
//                   <td style={{ color: item.subway === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)'}}>
//                     {item.subway}
//                   </td>
//                   <td style={{ color: item.air === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
//                      {item.air}
//                   </td>
//                   <td  className="total-cell" style={{ color: item.total === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
//                     {item.total}
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

//         {/* CABLE HIGHWAY */}
//       <div  className="scroll-container" style={{ flex: 1, marginTop: '10px', maxWidth:"400px", overflowY: 'auto', paddingBottom: '10px' }}>
        
//         <table className="results-table"> 
//           <thead>
//           <tr>
//             <td colspan="4"  style={{
//                 textAlign: 'center',
//                 fontSize: '14px',
//                 backgroundImage: 'linear-gradient(to right,rgb(56, 56, 56), #434343)',
//                 textShadow: '2px 2px 4px rgb(0, 0, 0)'
               
//               }}>
//               За 7 дней (ранг 1/2)
//             </td>
//           </tr>
//             <tr>
//               <th>Город</th>
//               <th>Подземка</th>
//               <th>Воздушка</th>
//               <th>Всего</th>
//             </tr>
//           </thead>
//           <tbody>
//             {result.length === 0 ? (
//               <tr>
//                 <td colSpan="4" className="no-data">Нет данных для отображения</td>
//               </tr>
//             ) : (
//               resultHighway.map((item, index) => (
//                 <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"} style={{ textShadow: '2px 2px 4px rgb(44, 44, 44)'}}>
//                   <td>{item.city}</td>
//                   <td style={{ color: item.subway === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
//                     {item.subway}
//                   </td>
//                   <td style={{ color: item.air === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)'  }}>
//                      {item.air}
//                   </td>
//                   <td  className="total-cell" style={{ color: item.total === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
//                     {item.total}
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>
  
//       <div style={{ flex: 1,  marginLeft:'-50px', marginTop: '10px' }}>
//         {/* {error && <p style={{ color: 'red' }}>{error}</p>} */}
  
//         <table className="results-table">
//           <thead>
//             <tr>
//               <th>Город</th>
//               <th>Колодец</th>
//               <th>Опора</th>
//               <th>Фоб</th>
//               <th>Муфта</th>
//               <th>Понбокс</th>
//             </tr>
//           </thead>
//           <tbody>
//             {resultComponent.length === 0 ? (
//               <tr>
//                 <td colSpan="6" className="no-data">Нет данных для отображения</td>
//               </tr>
//             ) : (
//               resultComponent.map((item, index) => (
//                 <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"} style={{textShadow: '2px 2px 4px rgb(44, 44, 44)'}}>
//                   <td >{item.city}</td>
//                   <td style={{ color: item.well === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
//                     {item.well}  
//                   </td>
//                   <td style={{ color: item.pillar === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
//                      {item.pillar}
//                   </td>
//                   <td style={{ color: item.fob === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
//                      {item.fob}
//                   </td>
//                   <td style={{ color: item.coupling === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
//                      {item.coupling}
//                   </td>
//                   <td style={{ color: item.ponBox === 0 ? '#e0656f' : '#5bcc87', textShadow: '2px 2px 4px rgb(44, 44, 44)' }}>
//                      {item.ponBox}
//                   </td>
//                 </tr>
//               ))
//             )}
//           </tbody>
//         </table>
//       </div>

    

//       <img 
//   src='./logo.png'  
//   alt='Logo' 
//   style={{
//     height: "350px",
//     width: "350px",
//     transition: "transform 2s ease",
//     animation: "rotate 20s linear infinite", // Добавляем анимацию
//   }}
//   onMouseEnter={(e) => {
//     e.currentTarget.style.transform = "scale(1.1) rotate(360deg)";
//     e.currentTarget.style.animation = "none"; // Останавливаем вращение при наведении
//   }}
//   onMouseLeave={(e) => {
//     e.currentTarget.style.transform = "scale(1) rotate(0deg)";
//     e.currentTarget.style.animation = "rotate 20s linear infinite"; // Возвращаем вращение
//   }}
// />

//       </div>
//       </>

//   );
// };

// export default Home;
